import { Chakra } from "@airhelp/react-ui-components";
import CustomHead from "modules/common/components/CustomHead";

interface Content {
  iframeSrc: string;
  iframeTitle: string;
}

interface Story {
  content: Content;
}

interface IframeTemplateProps {
  story: Story;
}

const { chakra } = Chakra;

const ChakraIframe = chakra("iframe");

const IframeTemplate = ({
  story: {
    content: { iframeSrc, iframeTitle },
  },
}: IframeTemplateProps) => (
  <>
    <CustomHead title={iframeTitle} />
    <ChakraIframe w="100vw" h="100vh" title={iframeTitle} src={iframeSrc} allowFullScreen />
  </>
);

export default IframeTemplate;
